export const PLEDGE_MANAGEMENT_TAB_IDS = {
  LEDGER: '0',
  AUCTION_OVER: '1',
  PFI: '2',
  AUCTION_MANAGER: '3',
  CLOSED_AUCTION: '4',
  CONFISCATIONS: '5',
  VULNERABLE: '6',
  POLICE_HOLD: '5', // replaced Confiscations
};

export const PLEDGE_MANAGEMENT_TAB_LABELS = {
  LEDGER: 'Ledger',
  AUCTION_OVER: 'Auction over 75.00',
  PFI: 'PFI 75.00 and under',
  AUCTION_MANAGER: 'Auction Manager',
  CLOSED_AUCTION: 'Closed Auctions',
  CONFISCATIONS: 'Confiscations',
  VULNERABLE: 'Vulnerable',
  POLICE_HOLD: 'Police Hold',
};

export const PLEDGE_MANAGEMENT_TABS = [
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.LEDGER,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.LEDGER,
    featureFlag: 'Evo-LedgerReview',
    isAuctionTab: false,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.AUCTION_OVER,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.AUCTION_OVER,
    featureFlag: '',
    isAuctionTab: true,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.PFI,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.PFI,
    featureFlag: 'EVO-PFI',
    isAuctionTab: true,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.AUCTION_MANAGER,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.AUCTION_MANAGER,
    featureFlag: '',
    isAuctionTab: true,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.CLOSED_AUCTION,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.CLOSED_AUCTION,
    featureFlag: '',
    isAuctionTab: true,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.CONFISCATIONS,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.CONFISCATIONS,
    featureFlag: '',
    isAuctionTab: false,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.POLICE_HOLD,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.POLICE_HOLD,
    featureFlag: 'Evo-PoliceHold',
    isAuctionTab: false,
  },
  {
    key: PLEDGE_MANAGEMENT_TAB_IDS.VULNERABLE,
    title: PLEDGE_MANAGEMENT_TAB_LABELS.VULNERABLE,
    featureFlag: '',
    isAuctionTab: false,
  },
];

export const AUCTION_MANAGER_TITLE = 'Auction Manager';
export const VIEWING_LABEL = 'Viewing';
export const FROM_DATE_LABEL = 'From';
export const TO_DATE_LABEL = 'To';
export const TO_DATE_REQUIRED_MSG = 'To date is required';
export const FROM_DATE_REQUIRED_MSG = 'From date is required';
export const AUCTION_VIEWING_OPTIONS = [
  { LABEL: 'All Auctions', OPTION_VALUE: 0 },
  { LABEL: 'Live At Store', OPTION_VALUE: 1 },
  { LABEL: 'Live At Auctions', OPTION_VALUE: 2 },
];
export const AUCTION_OVER_TITLE = 'Auction Over \u00A375.00';
export const AUCTION_OVER_REVIEW_TITLE = 'Auction Entry Review - ';
export const PFI_TITLE = 'PFI \u00A375.00 and under';
export const VIEW_AUCTION_DETAILS_TITLE = 'Auction Manager / View Auction - ';
export const VIEW_AUCTION_CLOSED_TITLE = 'Closed';
export const VIEW_AUCTION_LIVE_STORE_TITLE = 'Live at Store';
export const VIEW_AUCTION_PENDING_RETURN_TITLE = 'Pending Return';
export const VIEW_AUCTION_LIVE_AT_AUCTION_TITLE = 'Live At Auction';
export const VIEW_AUCTION_READY_FOR_AUCTION_TITLE = 'Ready For Auction';
export const TABLE_HEAD_COLOR = {
  CLOSED: 'rose-white',
  ACTIVE: 'honeydue',
  PENDING: 'light-yellow',
};
export const SUMMARY_STATUS_OPTIONS = [
  { id: 1, value: 'Pass' },
  { id: 2, value: 'Sold' },
  { id: 3, value: 'Return' },
];
export const CONFIRM_SETTLEMENT_HEADER = 'You are about to settle this auction';
export const CONFIRM_SETTLEMENT_CONTENT = 'Are you sure you wish to continue?';
export const CONFIRM_SETTLEMENT_TYPE = 'Type';
export const CONFIRM_SETTLEMENT_VOLUME = 'Volume';
export const CONFIRM_SETTLEMENT_VALUE = 'Value';
export const PROCEED_SETTLEMENT_HEADER =
  'You have chosen to settle this auction';
export const PROCEED_SETTLEMENT_CONTENT =
  'Are you really sure you wish to settle this auction?';
export const PROCEED_SETTLEMENT_WARNING = 'This action cannot be undone!';
export const AUCTION_PRINT_TYPE = {
  AUCTION_BOOK: 1,
  PASSES: 2,
};
export const AUCTION_PRINT_FOR = {
  LIVE_AT_STORE: 1,
  LIVE_AT_AUCTION: 2,
};

export const PFI_LABELS = {
  PFI_UNDER: 'Pfi Under',
  PFI_REVIEW: 'Pfi Review',
};

export const ADD_STONE_LABELS = {
  LABEL: 'View/Edit Stone Details',
  ANOTHER_STONE: 'Add Another Stone',
};

export const CONFIRM_ITEM_DETAILS = 'Confirm Item Details';
export const ITEM_DESCRIPTION = 'Item Description';
export const VALUATION = {
  METAL_VALUE: 'Metal Value',
  COIN_VALUE: 'Coin Value',
  STONES_TOTAL_VALUE: 'Stones Total Value',
  OVERALL_GUIDANCE: 'Overall Guidance',
  DESIRED_AMOUNT: 'Desired Amount',
  VALUATION: 'Valuation',
};
export const TAKE_ITEM_PHOTO = 'Take Item Photo';
export const TOTAL_ITEM_VALUE = 'Item Cost';
export const ITEM_TYPE = 'COINS';
export const CONFIRM_LOCK_HEADER = 'You are about to lock this auction';
export const CONFIRM_LOCK_CONTENT = 'Are you sure you wish to continue?';
export const LOCK_AUCTION_DATE = 'Auction Date';
export const LOCK_AUCTION_LOTS = 'No. of Lots';
export const LOCK_AUCTION_RESERVE_VALUE = 'Reserve Value';
export const RECONFIRM_LOCK_HEADER = 'You have chosen to lock this auction';
export const RECONFIRM_LOCK_CONTENT =
  'Are you really sure you wish to lock this auction?';
export const RECONFIRM_LOCK_WARNING = 'This action cannot be undone!';
export const REMINDER_AUCTION_HEADER =
  'This months auction is taking place tomorrow';
export const REMINDER_AUCTION_CONTENT = 'The auction must be locked at 6pm';
export const NOTIFY_LOCK_CALL_EXEC_TIME = 12; //In hours format, 12pm
export const NOTIFY_LOCK_CALL_INTERVAL = 86400000; //In milliseconds i.e 24 hours
export const REMINDER_AUCTION_ALERT_INTERVAL = 1800000; //In milliseconds i.e 30 minutes
export const CONFIRM_PASS_CONTENT =
  'Note: Existing Lot numbers will not be recalculated as labels may already be on the other items.';
export const CONFIRM_PASS_LABEL =
  'Please enter the reason for passing this lot';
export const NEXT_EXEC_TIME_INTERVAL = 86400000; //24 hrs in milliseconds

export const ADD_COIN_LABELS = {
  LABEL: 'View/Edit Coin Details',
  ANOTHER_COIN: 'Add Another Coin',
};
export const REASON_TEXT_PLACEHOLDER = 'Pass no pay - Advised by CR Team';
export const GENERATE_BUTTON_TEXT = 'Move To Auction';
export const AUCTION_RESERVE_TEXT = 'Auction Reserve Value';
export const NEXT_PLEDGE_BUTTON_TEXT = 'Next Pledge';
export const NO_PLEDGE_TEXT = 'No Pledge';
export const BARCODE_FAILED_TEXT = `Barcode's did not process successfully`;
export const BARCODE_STICKER_FAILED_TEXT = `Barcode service is not running, please check.`;
export const SENT_TO_PRINTER = `Sent to printer successfully`;
export const LOT_STICKER_SERVICE_ERROR = `Lot sticker service is not running, please check.`;
export const SUCCESS_RELEASE = 'Pledge released successfully.';

export const PLEDGE_MANAGEMENT_TITLES = {
  CONFISCATIONS: 'Confiscations',
  VULNERABLE: 'Vulnerable',
  POLICE_HOLD: 'Police Hold',
};

export const PLEDGE_ACTION_NOTES_TITLES = {
  CONFISCATE: 'Confiscate Pledge(s)',
  VULNERABLE: 'Mark Pledges(s) as Vulnerable',
  CONFISCATE_MANAGER: 'Confiscation Details',
  VULNERABLE_NOTES_TITLE: 'Vulnerable Pledge Details',
  POLICE_HOLD_MANAGER: 'Police Hold Details',
};

export const VULNERABLE_NOTICE_POPUP = {
  TITLE: 'Vulnerable Notice',
  CONTENT:
    'Are you sure you want to mark the pledge(s) listed above as vulnerable?',
};

export const CONFISCATE_NOTICE_POPUP = {
  TITLE: 'Confiscation Notice',
  CONTENT: `Are you sure you want to mark the pledge(s) listed above? If 'Yes' then please print and present an NPA statement to the officer to read and keep.`,
};

export const PLEDGE_NOTICE_TYPE = {
  CONFISCATE: 'Confiscate',
  VULNERABLE: 'Vulnerable',
};

export const RELEASE_PLEDGE_POPUP = {
  VULNERABLE_TITLE: 'Release Vulnerable Pledge',
  CONFISCATE_TITLE: 'Release Confiscated Pledge',
  CONTENT: `This will return the pledge to an open state and allow
  transactions and processing against it. `,
  VALIDATION_ERROR: 'Please add a reason for release.',
  //Polce Hold
  POLICE_HOLD: 'Release Police Hold',
};

export const BUTTON_LABELS = {
  SAVE_NOTE: 'Save Note',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
  PRINT_NPA_STATEMENT: 'Print NPA Statement',
  CONTINUE: 'Continue',
  RELEASE: 'Release',
  REPRINT: 'Reprint',
  FAILED: 'Failed',
  NEXT_PLEDGE: 'Next Pledge',
  PUSH_TO_PFI: 'Push To PFI',
  BACK_TO_PFI_MANAGER: 'Back To PFI Manager',
  BACK_TO_AUCTION_MANAGER: 'Back To Auction Manager',
  RETRY_RECHECK: 'Retry/Recheck Status',
  SEND_EMAIL: 'Send Email',
  OK: 'OK',
  REPRINT_LOT_LABEL: 'Reprint Lot Label',
  BACK: 'Back',
  PROCEED: 'Proceed',
  LOCK_AUCTION: 'Lock Auction',
  PRINT_AUCTION_BOOK: 'Print Auction Book',
  PRINT_PASSES: 'Print Passes',
  CONFIRM_COLLECTION: 'Confirm and Seal Bag',
  EMAIL_AUCTION_BOOK: 'Email Auction Book',
  PRINT_LOT_LABEL: 'Print Lot Label',
  SETTLE_AUCTION: 'Settle Auction',
  YES: 'Yes',
  NO: 'No',
  SEND_TO_AUCTION_HOUSE: 'Send To Auction House',
  PASS_LOAN: 'Pass Loan',
  SEARCH: 'Search',
  CLOSE: 'Close',
  DELETE: 'Delete',
  EDIT_BAG_CONTENTS: 'Edit Bag Contents',
  REVIEW_PROCESS_CHAPTER: 'Review/Process Chapter',
  VIEW_CHAPTER: 'View Chapter',
  CREATE_NEW_BAG: 'Create New Bag',
  MOVE_PLEDGE: 'Move Pledges(s)',
  CREATE: 'Create',
  RESET: 'Reset',
  PRINT: 'Print',
};

export const AUCTION_TYPE = {
  ACTIVE: 1,
  CLOSED: 2,
};

export const COURIER_COMPANY = {
  ALL_BAGS: 0, // to show all bags irrespective of courier company
};

export const AUCTION_BAG_STATUS = {
  ALL: 0,
  OPEN: 1,
  SEALED: 2,
  COLLECTED: 3,
  CHAPTER_RECEIVED: 5,
  REJECTED: 6,
};

export const AUCTION_BAG_LOCATION = {
  STORE: 1,
  AUCTION_HOUSE: 2,
};

export const AUCTION_ERROR_MSG = {
  LOAN_NOT_FOUND: 'Loan Not Found',
  SEARCH: 'Please fill all fields before clicking Search',
  AUCTION_DATE_NOT_FOUND: 'Auction date not found for this loan.',
};

export const AUCTION_POPUP_TITLES = {
  EDIT_BAG_CONTENTS: 'Edit Bag Contents',
  CREATE_NEW_BAG: 'Create New Bag',
  OPEN_BAGS: 'Open Bags',
};

export const movePledge = (loan) => `Move Pledge (${loan}) to an available bag`;
export const ADD_NOTE_ERROR = 'Please add a note.';

export const CONFISCATION_GRID_HEADERS = {
  CUSTOMER_IMAGE: {
    NAME: ' ',
    TITLE: ' ',
  },
  CUSTOMER_NAME: {
    NAME: 'customerName',
    TITLE: 'Customer Name',
  },
  SERVICE: {
    NAME: 'serviceType',
    TITLE: 'Service Type',
  },
  AGREEMENT: {
    NAME: 'loanNumber',
    TITLE: 'Agreement',
  },
  AMOUNT: {
    NAME: 'amount',
    TITLE: 'Amount',
  },
  START_DATE: {
    NAME: 'startDate',
    TITLE: 'Start Date',
  },
  END_DATE: {
    NAME: 'dueDate',
    TITLE: 'End Date',
  },
  CONFISCATED: {
    NAME: 'confiscatedDate',
    TITLE: 'Confiscated',
  },
};

export const CONFISCATION_EXPANDABLE_GRID_HEADERS = {
  ITEM_IMAGE: {
    NAME: ' ',
    TITLE: 'Item Image',
  },
  DESC: {
    NAME: 'description',
    TITLE: 'Description',
  },
  WEIGHT: {
    NAME: 'weight',
    TITLE: 'Weight',
  },
  AMOUNT: {
    NAME: 'amount',
    TITLE: 'Amount',
  },
};

export const CONFISCATION_RETAIL_EXPANDABLE_GRID_HEADERS = {
  ITEM_IMAGE: {
    NAME: ' ',
    TITLE: 'Item Image',
  },
  DESC: {
    NAME: 'notes',
    TITLE: 'Description',
  },
  WEIGHT: {
    NAME: 'totalWeight',
    TITLE: 'Weight',
  },
  AMOUNT: {
    NAME: 'costPrice',
    TITLE: 'Amount',
  },
};

export const AUCTION_BAG = {
  MAX_VALUE: 20000,
  CREATED: 'New Bag created successfully.',
  PLEDGE_ADDED_TO_BAG: 'Pledge is successfully added to Bag.',
  PLEDGE_NOT_ADDED_TO_BAG: 'Pledge could not be added to Bag.',
  ADVISORY: 'Advisory',
  BAG_VALIDATION:
    'Adding this pledge to the current bag will exceed the standard carrier insurance value. <br> Please arrange additional insurance.',
};

export const AUCTION_BAG_CATEGORY = {
  ALL: 0,
  BY_STATUS: 1,
  BY_BAG_ID: 2,
};

export const AUCTION_COURIER_COMPANY_ID = 0;

export const AUCTION_LOCATION_ID = 1;

export const PLEDGE_ID_FOR_MOVE = 0;

export const AUCTIONS_NOTIFICATION_MESSAGES = {
  AUCTION_PLEDGE_MOVE_SUCESSS: 'Auction pledge moved sucessfully',
  AUCTION_PLEDGE_MOVE_FAILURE: 'Auction pledge move operation failed',
  AUCTION_BAG_CREATE_SUCESSS: 'Auction bag created successfully',
  AUCTION_BAG_CREATE_FAILURE: 'Auction bag creation failed',
  AUCTION_BAG_DELETE_SUCESSS: 'Auction bag deleted successfully',
  AUCTION_BAG_DELETE_FAILURE: 'Auction bag deletion failed',
  AUCTION_BAG_SEAL_SUCESSS: 'Auction bag sealed successfully',
  AUCTION_BAG_SCAN_SUCESSS: 'Auction bag scanned successfully',
  AUCTION_BAG_SEAL_FAILURE: 'Auction bag seal failed',
  AUTHORIZATION_FOR_SEAL_BAG_SUCCESS: 'Authorization Successful',
  AUTHORIZATION_FOR_SEAL_BAG_FAILURE: 'Authorization Failed',
  AUCTION_BULK_SELECT_FAILURE: 'Bulk confirm failed. Please try again.',
};

export const SEAL_AUTH_POPUP = {
  EMPLOYEE_ID: 'Employee ID',
  PASSWORD: 'Password',
  ERROR_MSG: {
    EMPLOYEE_ID: 'Employee ID is required',
    PASSWORD: 'Password is required',
  },
  NOTIFICATION: {
    SUCCESS: 'Auction Bag Sealed Successfully',
  },
};

export const DELETE_BAG_POPUP = {
  HEADER: 'Alert',
  TEXT_ONE:
    'Removing this bag will remove these pledges from the auction and return them to the PFA screen',
  TEXT_TWO: 'Are you sure ?',
  FINAL_CONFIRM_TEXT_ONE:
    'Are you sure you want to remove these pledges from the Auction?',
  FINAL_CONFIRM_TEXT_TWO: 'This cannot be undone!',
  EMPTY_BAG_DELETE_CONFIRM_TEXT:
    'Are you sure you want to remove this bag from the auction?',
};

export const PAGINATION_GRID = {
  PAGE_SIZE: 50,
};

export const AUCTION_BAG_STATUS_TEXTS = {
  SEALED: 'Sealed',
  RECEIVED_AT_JC: 'Received At JC',
  REJECTED: 'Rejected At JC',
};

export const PFI_ERRORS = {
  BARCODE_NOT_FOUND: 'The barcode is not available for PFI ',
  PLEDGE_LIST_NOT_FOUND:
    'The list of PFI Pledges is not available. Please try again after some time.',
  PURCHASE_LIST_NOT_FOUND:
    'The list of PFI Purchases is not available. Please try again after some time.',
  LIST_NOT_FOUND: 'The list is not found. Please try again after some time.',
  PFI_FAILED: 'Push to PFI failed. Please try again.',
  PFI_BULK_SELECT_FAILURE: 'Bulk confirm failed. Please try again.',
};

export const TOGGLE_SWITCH = {
  PLEDGE: 'Pledge',
  PURCHASE: 'Purchase',
};

export const MANUAL_SELECTION_REQUIRED_POPUP = {
  HEADER: 'Manual Selection Required',
  TEXT_ONE: 'Process failed again. Please select items individually.',
  TEXT_TWO: 'All items must be confirmed before Push to ',
};
export const REVIEW_TYPE = {
  PFI: 'PFI',
  PFA: 'PFA',
};

export const IS_PURCHASE_PFI = {
  IS_QUARANTINE: 0,
  PURCHASE_STATUS: 3,
};

export const AUCTION_BAG_LENGTH_MSG =
  'For G4S couriers, reference must be exactly 12 digits';

export const COURIER_COMPANIES = {
  G4S: 'G4S',
};

// LEDGER CONSTANTS
export const LEDGER_TITLE = 'Ledger';
export const LEDGER_TYPES = {
  PLEDGE: 'New Pledge',
  PURCHASE: 'Purchase',
  PAYDOWN_RENEW: 'Renew/Paydown',
};

export const ALERT_MESSAGE = {
  SUCCESS: {
    PLEDGE_REVIEW: 'Pledge reviewed successfully.!!',
    PURCHASE_REVIEW: 'Purchase reviewed successfully.!!',
    MOVE_PURCHASE_BAGS: 'Reviewed purchase bags moved successfully.',
    MOVE_PLEDGE_BAGS: 'Reviewed pledge bags moved successfully.',
  },
};

export const ROLE_NAMES = {
  PASS_NO_PAY: 'PassNoPay',
};

export const PASS_NO_PAY_POPUP = {
  ALERT: 'Please ensure the following passed loans have been removed.',
  ALERT_FAILED_LETTERS:
    'Letter generation failed for the following pledges for this auction and will be removed from the chapter',
  ERROR: 'Error fetching Pass No Pay loans',
  TABLE_HEADERS: {
    LOAN_NUM: 'Loan Number',
    DATE: 'Pass No Pay Date',
    USER: 'User',
  },
};

export const AUCTION_LOAN_STATUS: any = {
  0: 'In Auction',
  1: 'Returned',
  2: 'Sold',
  3: 'Void',
  4: 'Pass',
};

export const AUCTION_STATUS: any = {
  1: 'Live At Store',
  2: 'Live At Auction',
  3: 'Under Auction',
  4: 'Pending for Settlement',
  5: 'Settled',
  6: 'Closed',
};

export const POLICE_HOLD_GRID_HEADERS = {
  CUSTOMER_IMAGE: {
    NAME: ' ',
    TITLE: ' ',
  },
  CUSTOMER_NAME: {
    NAME: 'customerName',
    TITLE: 'Customer Name',
  },
  SERVICE_TYPE: {
    NAME: 'serviceType',
    TITLE: 'Type',
  },
  AGREEMENT: {
    NAME: 'reference',
    TITLE: 'Reference',
  },
  COST: {
    NAME: 'amount',
    TITLE: 'Cost',
  },
  TRANSACTION_DATE: {
    NAME: 'transactionDate',
    TITLE: 'Transaction Date',
  },
  POLICE_HOLD_DATE: {
    NAME: 'confiscatedDate',
    TITLE: 'Date of Police Hold',
  },
  UPDATED_DATE: {
    NAME: 'updatedOn',
    TITLE: 'Updated Date',
  },
  ITEM_LOCATION: {
    NAME: 'confiscatedLocation',
    TITLE: 'Item Location',
  },
};
